import React, { useState } from 'react';
import { Input, Typography } from 'antd';
import { SaveButton, TagInput, TagsSubTitle } from './CreateTag.styles';
import ColorPicker from '../../../components/common/colorPicker/ColorPicker';
import { SubTitle } from '../../../styles/common.styles';
import { alertService } from '../../../services';
import { useAppDispatch } from '../../../hooks/redux';
import { useDefaultColor } from '../../../hooks/useDefaultColor';
import { createTagAction } from '../../../redux/actions/tagActions';
import { TableData } from '../../../models/tableData/types';
import { TAG_NAME_MAX_LENGTH } from '../../../utils/tagUtils';

interface CreateTagProps {
    fetchTags: (data: TableData) => void;
    tableData: TableData;
}

const CreateTag: React.FC<CreateTagProps> = ({ fetchTags, tableData }) => {
    const [tag, setTag] = useState('');
    const [color, setColor] = useDefaultColor();
    const [popoverVisible, setPopoverVisible] = useState(false);
    const dispatch = useAppDispatch();

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTag(e.target.value);
    };

    const handleSave = async () => {
        if (!tag.trim()) {
            alertService.error('Tag name is required');
            return;
        }
        if (!color) {
            alertService.error('Please select a color');
            return;
        }
        const result = await dispatch(createTagAction({ name: tag.trim(), colorId: color.id }));
        if (createTagAction.fulfilled.match(result)) {
            alertService.success('Tag created successfully');
            setTag('');
            setColor(null);
            fetchTags(tableData);
        }
    };
    return <>
        <TagsSubTitle>
            <Typography.Text style={{ fontFamily: 'Proxima N W15 Bold' }}>Create, edit or delete tags</Typography.Text> that users with tagging privileges can add to products in Projects and Favorite Product Libraries.
        </TagsSubTitle>
        <SubTitle>
            Add new tag
        </SubTitle>
        <TagInput>
            <Input
                placeholder={'Enter tag name; then select color'}
                onChange={handleInputChange}
                value={tag}
                id='add-tag-input'
                maxLength={TAG_NAME_MAX_LENGTH}
                style={{ width: 280 + 'px', marginRight: 0, marginTop: '5px' }}
            />
            <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <ColorPicker
                    color={color}
                    setColor={setColor}
                    popoverVisible={popoverVisible}
                    setPopoverVisible={setPopoverVisible}
                />
            </span>
        </TagInput>
        <SaveButton onClick={handleSave}>Save</SaveButton>
    </>;
};

export default CreateTag;
